import { getImageAttributes } from '@notino/react-web-utils';
import { GetProductViewQuery } from '@notino/shared/definitions/types';

export const getImagesAttributes = (
  images: GetProductViewQuery['productDetailByMasterId'][number]['variants'][number]['imagesByCategory']['mainImage'][],
  domain: string,
  sourceKey: string
) => images.map((image) => getImageAttributes(image, domain, sourceKey));
